export const COMPANY = {
  brandName: "Lead Conversa",
  productTagline:
    "Plataforma de conversação e marketing para times que vendem pela conversa.",
  legalEntity: "Avante Capacitações",
  cnpj: "44.448.585/0001-82",
  address: {
    street: "Rua Luiz Figueiredo Filho, 390, sala 65",
    city: "São José do Rio Preto",
    state: "SP",
    country: "Brasil",
  },
  addressFormatted:
    "Rua Luiz Figueiredo Filho, 390, sala 65 – São José do Rio Preto/SP – Brasil",
  // Host canônico é www (leadconversa.com.br redireciona). As URLs abaixo são
  // as cadastradas no app da Meta (Política, Termos, Exclusão de dados) — o
  // revisor abre exatamente estas.
  website: "https://www.leadconversa.com.br",
  privacyUrl: "https://www.leadconversa.com.br/privacidade",
  termsUrl: "https://www.leadconversa.com.br/termos",
  lgpdUrl: "https://www.leadconversa.com.br/lgpd",
  dataDeletionUrl: "https://www.leadconversa.com.br/exclusao-de-dados",
  dpoEmail: "privacidade@leadconversa.com.br",
  supportEmail: "suporte@leadconversa.com.br",
  lastUpdatedLegal: "20 de setembro de 2026",
} as const;
